import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import ListingImage from '../../ListingImage/ListingImage';
import { Text } from '../../Typography';

interface BuyerAppointmentListItemProps {
  appointment: any;
}

const BuyerAppointmentListItem: React.FC<BuyerAppointmentListItemProps> = ({
  appointment,
}) => {
  const { time, timeEnd, listing } = appointment;
  const fullAddress = `${listing.line1}${
    listing.line2 ? ` ${listing.line2}` : ''
  }`;
  return (
    <Container>
      <ImageContainer>
        <ListingImage imageSrc={listing.thumbnail} />
      </ImageContainer>
      <TextContainer>
        <Text>
          <Text strong>{fullAddress}</Text> {listing.city}, {listing.province}
        </Text>
        <StyledSubText>
          {moment(time).format('MMM D, YYYY')}
          <DotIcon />
          {moment(time).format('h:mma')} - {moment(timeEnd).format('h:mma')}
          {}
        </StyledSubText>
      </TextContainer>
    </Container>
  );
};

export default BuyerAppointmentListItem;

const Container = styled.div`
  display: flex;
  align-items: center;
  min-height: 60px;
  padding: 4px;
`;

const ImageContainer = styled.div`
  padding: 4px 8px;
`;

const TextContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-flow: column;
  justify-content: center;
  font-size: 12px;
  line-height: 20px;
  overflow: hidden;
`;

const StyledSubText = styled(Text)`
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.45);
`;

export const DotIcon = styled.span`
  width: 4px;
  height: 4px;
  background: rgba(0, 0, 0, 0.45);
  border-radius: 50%;
  margin: 0 5px;
`;
